<!-- 
程式：web2020Q1WT.vue
功能：員工獎勵活動網頁
作者：i9400540 施義濃
完成：2020-01-08
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <header
        class="l-header"
        style="width: 100%; position: fixed; z-index: 99; margin-top: -8px"
      >
        <div class="l-header__wrap">
          <div class="l-header__content">
            <div class="l-header__logo">
              <a href="javascript:;" id="CI_Link">
                <picture>
                  <source
                    srcset="@/assets/webpage/action1/images/logo/logo-m.svg"
                    media="(max-width: 1040px)"
                  />
                  <img
                    srcset="@/assets/webpage/action1/images/logo/logo.svg"
                    class="o-logo"
                    alt
                    style="width: 137px"
                  />
                </picture>
              </a>
              <a
                :href="VUE_APP_LINK_WTHOME"
                target="_blank"
                title="回網路投保首頁"
              >
                <span>網路投保</span>
              </a>
            </div>
          </div>
          <nav class="l-nav">
            <ul class="c-menu" data-tab-sliders>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section4')"
                  >有保障有保佑</a
                >
              </li>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section2')"
                  >雙喜臨門</a
                >
              </li>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section8')"
                  >年金只刷世華卡</a
                >
              </li>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section6')"
                  >分享親友拿獎金</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <main class="l-main" style="margin-top: 60px">
        <!-- KV -->
        <section class="l-mainKv">
          <div class="l-mainKv__slider slick-initialized slick-slider">
            <div class="slick-list draggable">
              <div
                class="o-banner"
                style="width: 100%; display: inline-block; margin-top: 5px"
              >
                <picture>
                  <source
                    srcset="@/assets/webpage/action1/images/kv/kv_800x900.jpg"
                    media="(max-width: 767px)"
                  />
                  <source
                    srcset="@/assets/webpage/action1/images/kv/kv_1200x1920.jpg"
                    media="(max-width: 1023px)"
                  />
                  <img
                    srcset="@/assets/webpage/action1/images/kv/kv_1600x600.jpg"
                    class="o-banner__photo"
                    alt
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
        <!-- section1 -->
        <section class="l-indexAd">
          <h2
            class="l-insurancePlan__title o-heading"
            style="text-align: center"
          >
            名額倒數中!!!
          </h2>
          <div class="l-mainProduct__container">
            <!-- 基本方案 -->
            <div class="l-cols__6 l-cols__6@t l-cols__12@m">
              <div class="c-productCard">
                <div class="c-productCard__main">
                  <div
                    class="c-pdContent__title section1"
                    style="color: #ffffff"
                  >
                    <div class="img1" style="position: relative">
                      <div class="number_1">
                        {{ patchZERO(req.BASIC_LIFE) }}
                      </div>
                      <div class="number_2">
                        {{ patchZERO(req.BASIC_ACCIDENT) }}
                      </div>
                      <div class="number_3">
                        {{ patchZERO(req.BASIC_TRAVEL) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 雙喜臨門 -->
            <div class="l-cols__6 l-cols__6@t l-cols__12@m">
              <div class="c-productCard">
                <div class="c-productCard__main">
                  <div
                    class="c-pdContent__title section1"
                    style="color: #ffffff"
                  >
                    <div class="img2" style="position: relative">
                      <div class="number_1">
                        {{ patchZERO(req.DOUBLE_LIFE) }}
                      </div>
                      <div class="number_2">
                        {{ patchZERO(req.DOUBLE_ACCIDENT) }}
                      </div>
                      <div class="number_3">
                        {{ patchZERO(req.DOUBLE_TRAVEL) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- section4 -->
        <section class="l-mainProduct" style="margin-top: 3%" id="section4">
          <div class="l-wrap">
            <div class="l-mainProduct__container">
              <div class="c-pdContent">
                <div class="c-pdContent__head">
                  <p class="l-mainProduct__title o-heading">
                    投保任一保障型商品
                    <br />
                    <font style="color: #000000; font-size: 25px">
                      即拿回饋獎金和媽祖光明燈乙盞
                      <br />有保有保障
                    </font>
                  </p>
                </div>
              </div>
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a :href="`javascript:;`" id="insurance01PIC">
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_1_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_1_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_1_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <p class="c-productCard__desc">
                        壽險:保費達1萬元(含)以上
                        <br />• 獲得1000元 <br />• 媽祖光明燈乙盞
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__desc" style="text-align: center">
                    <a
                      :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE3_1000/prompt`"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_life_e"
                      style="width: 145px; margin: 1%"
                      >新e把罩</a
                    >
                    <a
                      :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE2_1000/prompt`"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_life_i"
                      style="width: 145px; margin: 1%"
                      >iLove</a
                    >
                  </div>
                </div>
              </div>
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a :href="`javascript:;`" id="insurance02PIC">
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_2_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_2_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_2_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                            style="
                              background-size: cover;
                              background-repeat: no-repeat;
                              background-position: 50% 50%;
                            "
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <p class="c-productCard__desc">
                        意外險:保費達1,499元(含)以上
                        <br />• 獲得200元 <br />• 媽祖光明燈乙盞
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__desc" style="text-align: center">
                    <a
                      :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID0_1000/prompt`"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_icarry"
                      style="width: 145px; margin: 1%"
                      >iCarry</a
                    >
                    <a
                      :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID1_1000/prompt`"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_eacc"
                      style="width: 145px; margin: 1%"
                      >新e路平安</a
                    >
                  </div>
                </div>
              </div>
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a :href="`javascript:;`" id="insurance04PIC">
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_4_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_4_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action1/images/section4/section4_4_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                            style="
                              background-size: cover;
                              background-repeat: no-repeat;
                              background-position: 50% 50%;
                            "
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <p class="c-productCard__desc">
                        旅平險:保費達1,100元(含)以上
                        <br />• 獲得200元 <br />• 媽祖光明燈乙盞
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__desc" style="text-align: center">
                    <a
                      :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIB0_1000/prompt`"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_travel"
                      style="width: 145px; margin: 1%"
                      >e悠遊</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- section2 -->
        <section class="l-indexAd" id="section2">
          <div class="l-mainProduct__container" style="max-width: 100%">
            <div class="c-pdContent">
              <div class="c-pdContent__head">
                <p class="l-mainProduct__title o-heading">
                  或投保任一保障+年金
                  <br />
                  <font style="color: #000000; font-size: 25px"
                    >獎金拿更多，還有媽祖光明燈乙盞</font
                  >
                </p>
              </div>
            </div>
            <div class="o-banner" style="width: 100%; display: inline-block">
              <picture>
                <source
                  srcset="
                    @/assets/webpage/action1/images/section2/section2_800x900.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    @/assets/webpage/action1/images/section2/section2_1200x1920.jpg
                  "
                  media="(max-width: 1023px)"
                />
                <img
                  srcset="
                    @/assets/webpage/action1/images/section2/section2_1600x600.jpg
                  "
                  class="o-banner__photo"
                  alt="僅供國泰人壽員工及其親友服用"
                  id="section2"
                />
              </picture>
            </div>
          </div>
        </section>
        <!-- section8 -->
        <section class="l-mainProduct" style="margin-top: 3%" id="section8">
          <div class="l-wrap">
            <div class="l-pageTab__section">
              <div class="c-pdContent">
                <div class="c-pdContent__head">
                  <p class="l-mainProduct__title o-heading">
                    投保年金只刷國泰世華卡
                  </p>
                </div>
              </div>
              <div class="c-adCard">
                <div class="c-adCard__img">
                  <picture>
                    <source
                      srcset="
                        @/assets/webpage/action1/images/section8/section8_450x280.jpg
                      "
                      media="(max-width: 767px)"
                    />
                    <source
                      srcset="
                        @/assets/webpage/action1/images/section8/section8_450x280.jpg
                      "
                      media="(max-width: 1023px)"
                    />
                    <img
                      srcset="
                        @/assets/webpage/action1/images/section8/section8_450x280.jpg
                      "
                      alt="投保年金只刷國泰世華卡"
                    />
                  </picture>
                </div>
                <div class="c-adCard__text" style="height: 250px">
                  <p style="text-align: center">
                    <br />
                    <span
                      class="l-insurancePlan__title o-heading"
                      style="color: rgb(0, 0, 0); font-size: 25px"
                    >
                      刷國泰世華卡投保鑫Money，
                      <br />登錄享2.5%回饋。
                    </span>
                    <br />
                  </p>
                  <div
                    class="card_button, button_margin"
                    style="text-align: center"
                  >
                    <div class="l-cols__6 l-cols__6@t l-cols__12@m">
                      <div class="card_button">
                        <a
                          :href="`https://www.cathaybk.com.tw/cathaybk/personal/credit-card/discount/event/payment/online-ins-money/`"
                          target="_blank"
                          class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                          id="searchID_btn"
                          style="width: 210px; margin-top: 2%"
                          >前往登錄</a
                        >
                      </div>
                    </div>
                    <div class="l-cols__6 l-cols__6@t l-cols__12@m">
                      <div class="card_button">
                        <a
                          :href="`https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC1_1000/prompt?_ga=2.180922471.1123785935.1582502526-1828726305.1582161596`"
                          target="_blank"
                          class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                          id="searchID_btn"
                          style="width: 210px; margin-top: 2%"
                          >已登錄，立即投保</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- section6 -->
        <section class="l-indexAd" id="section6" style="margin-top: 3%">
          <div class="l-mainProduct__container" style="max-width: 100%">
            <div class="o-banner" style="width: 100%; display: inline-block">
              <picture>
                <source
                  srcset="
                    @/assets/webpage/action1/images/section6/section6_1920x500.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    @/assets/webpage/action1/images/section6/section6_1200x1920.jpg
                  "
                  media="(max-width: 1023px)"
                />
                <img
                  srcset="
                    @/assets/webpage/action1/images/section6/section6_1600x600.jpg
                  "
                  class="o-banner__photo"
                  alt="僅供國泰人壽員工及其親友服用"
                  id="section6"
                />
              </picture>
            </div>
          </div>
        </section>
        <!-- section7-1 -->
        <span class="anchor" id="section7-1"></span>
        <section class="l-indexAd" style="margin-top: 3%">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: left"
            >
              &lt;活動辦法&gt;
            </h2>
            <div class="l-pageTab__content u-gutterNext--md">
              <ul class="o-list o-list--decimal">
                <li>活動期間:即日起至3月31日。</li>
                <li>參加資格:</li>
                <p>
                  1)限國泰人壽在職內外勤員工(除業專、服中客服專員)。
                  <br />2)國泰人壽員工可分享推薦序號，推薦給非公司現職員工之親友投保，推薦人須為在職員工(查詢推薦序號須先加入國泰人壽官網會員)。
                  <br />3)得獎者須為國泰人壽員工，且領獎時在職。
                  <br />4)員工可重複參加員工獎勵活動，得獎者可重複得獎。
                  <br />5)如參加者先後購買壽險、意外險、年金險，意外險得基本方案獎，壽險與年金可搭配得雙喜臨門獎，雙喜臨門獎以最高獎開始扣除名額。
                  <br />
                </p>
              </ul>
            </div>
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: left"
            >
              &lt;獎項內容&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <ul class="o-list o-list--decimal">
                <li>符合員工獎勵投保門檻，即得體驗獎金如下，</li>
                <table
                  style="
                    border-collapse: collapse;
                    border: 1px solid;
                    margin: 15px 0 15px 50px;
                  "
                >
                  <tr style="background-color: #c5e0b5">
                    <td class="table_td">方案</td>
                    <td class="table_td" colspan="2">獲獎條件</td>
                    <td class="table_td">贈品(現金)</td>
                  </tr>
                  <tr>
                    <td
                      style="
                        font-weight: 900;
                        border: 1px solid;
                        padding: 2.5px 5px;
                      "
                      rowspan="3"
                    >
                      基本方案
                    </td>
                    <td class="table_td">壽險:新e把罩、iLove</td>
                    <td class="table_td">保費1萬元(含)以上</td>
                    <td class="table_td">1000元</td>
                  </tr>
                  <tr>
                    <td class="table_td">意外險：新e路平安、iCarry</td>
                    <td class="table_td">保費1,499元(含)以上</td>
                    <td class="table_td">200元</td>
                  </tr>
                  <tr>
                    <td class="table_td">旅平險</td>
                    <td class="table_td">保費1,100元(含)以上</td>
                    <td class="table_td">200元</td>
                  </tr>
                  <tr>
                    <td
                      style="
                        font-weight: 900;
                        border: 1px solid;
                        padding: 2.5px 5px;
                      "
                      rowspan="3"
                    >
                      雙喜臨門
                    </td>
                    <td class="table_td" rowspan="3">保障型搭配年金險</td>
                    <td class="table_td">
                      壽險(符合以上門檻)+年金險(單筆30萬元(含)以上)
                    </td>
                    <td class="table_td">2500元</td>
                  </tr>
                  <tr>
                    <td class="table_td">
                      意外險(符合以上門檻)+年金險(單筆30萬元(含)以上)
                    </td>
                    <td class="table_td">1100元</td>
                  </tr>
                  <tr>
                    <td class="table_td">
                      旅平險(符合以上門檻)+年金險(單筆30萬元(含)以上)
                    </td>
                    <td class="table_td">1100元</td>
                  </tr>
                </table>
                <li>
                  同時，單筆投保基本方案中任一保障型商品，即可獲得媽祖光明燈乙盞。
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- section7-2 -->
        <span class="anchor" id="section7-2"></span>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: left"
            >
              &lt;其它注意事項&gt;
            </h2>
            <div class="l-pageTab__content u-gutterNext--md">
              <ul class="o-list o-list--decimal">
                <p>
                  參加者於參加本活動時，即表示同意本活動辦法，並充分知悉與同意以下事項:
                </p>
                <li>
                  本單位保有修改、變更或暫停本活動之權利，如有未盡事宜，悉依數位發展部解釋為準，並得隨時補充公告之。
                </li>
                <li>
                  參加者須於獎勵期間完成繳費且無撤銷或解約情事者方可計入；若參加者於領獎前辦理契約撤銷或解約，該新契約所獲得之得獎資格將予取消。
                </li>
                <li>
                  參加者於參加本活動時，即表示同意本活動辦法，並充分知悉與同意以下事項：
                </li>
                <li>
                  公司得因本活動之需要，依個人資料保護相關規定，於參加者同意之期間內，以電子檔或紙本形式於我國境內蒐集、處理、利用其個人資料。但公司
                  於未經參加者之同意下，不得利用參加者之個人資料進行商業行銷行為。參加者可自由選擇是否提供完整個人資訊，惟若資訊不完整者，將無法參加
                  本活動。
                </li>

                <li>
                  參加者可電洽公司主辦單位之專線(2326 3399 分機
                  33426)，針對其個人資料行使請求答覆查詢、提供閱覽、製給複製本、更正、補充、停止蒐集、處
                  理、利用或刪除之權利，亦可至公司官方網站法令公告之「個人資料保護法」應告知事項專區
                  (網址：
                  https://www.cathayholdings.com/life/B2CWebGroup/pages/privacy/privacylist.html)
                  進一步了解詳細資訊。
                </li>
                <li>
                  本活動如有任何因電腦、網路、電話、技術或其他不可歸責於公司之事由，致參加者所寄出、填寫或登錄之資料有遺失、錯誤、無法辨識或毀損等情
                  形，公司不負任何法律責任。
                </li>
                <li>
                  公司有權檢視得獎情況是否有人為操作之行為，對於以偽造、詐欺或其他不正當之方式意圖兌領之參加者，公司有權撤銷其得獎資格或拒絕其參與本
                  活動。
                </li>
                <li>
                  得獎者身分之認定係依公司資料庫電子郵件所對應之身分證字號或統一編號為主，並須提供正確之身分證影本，且經公司確認無誤後始得領獎。
                </li>

                <li>
                  本活動獎品寄送地址僅限中華民國境內，如得獎者未能於領獎期限前回覆有效國內寄送地址，公司得取消其得獎資格。
                </li>
                <li>
                  得獎者逾期未領獎或因留存資料不完整或錯誤致無法通知得獎者，視同放棄得獎資格，不接受開立扣繳憑單者，亦同。
                </li>
                <li>本活動獎品不得要求轉換、轉讓或折換現金。</li>
                <li>
                  本活動獎品悉以實物為準，如遇缺貨或不可抗力之因素無法提供時，公司有權以其他等值商品替代。
                </li>

                <li>
                  依稅法規定，得獎者若為中華民國境內居住之個人，且年度所得獎項價值累積超過新臺幣
                  1,000 元時，公司將於翌年開立所得稅扣繳憑單予得獎者。
                  得獎者若為非中華民國境內居住之個人(即在中華民國境內居住未達
                  183
                  天之本國人及外國人)，不論得獎獎項價值，均須先就得獎所得扣繳 20
                  ％機會中
                  獎稅金，始可領獎，公司並將依法須開立所得稅扣繳憑單。若未能依法繳納應繳稅額，即視為喪失得獎資格。參加者因參加本活動而須支付之任何稅
                  捐皆為參加者之義務，概與公司無關。前述稅捐法規如有更新或變動者，依修正後之規定辦理。
                </li>
                <li>
                  公司非獎品製造者或提供者，與各項獎品或服務之製造或提供廠商無任何代理或合夥關係，且本活動獎品之保固期限均依廠商出廠時實際提供者為準。得獎者如因本活動各項獎品、服務或保固發生任何爭議，概與公司無關。
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <footer class="l-footer">
        <div class="l-footer__contactUs">
          <div class="l-footer__wrap">
            <ul class="c-footLinks">
              <li>
                <a
                  :href="VUE_APP_LINK_MEMBER"
                  target="_blank"
                  class="c-footLinks__link"
                  >會員專區</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_CONNECTION"
                  target="_blank"
                  class="c-footLinks__link"
                  >聯絡我們</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_SECRET"
                  target="_blank"
                  class="c-footLinks__link"
                  >顧客資料保密措施</a
                >
              </li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="l-footer__copyright">
          <div class="l-footer__wrap">© 國泰人壽保險股份有限公司</div>
        </div>
      </footer>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>

    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%;margin: 0 auto;">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right: 5px"
            data-mfp-close
            >取消</a
          >
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left: 5px"
            >立即前往</a
          >
        </div>
      </div>
    </div>

    <div id="CI_LINK_MSG2" class="mfp-hide" style="width: 30%;margin: 0 auto;">
      <div class="c-popup__head" data-alert="title">提醒</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content" style="text-align: left">
          很抱歉！本活動限國泰人壽在職內外勤員工(除業專、服中客服專員)，您將離開本頁面，並前往網路投保網站。
        </div>
        <div class="c-popup__actions">
          <a @click="gotoCathayLife" class="o-btn o-btn--normal o-btn--primary"
            >立即前往</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DTODAVZ1 from "@/service/DTODAVZ1.js";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "ODAVF100",
  data() {
    return {
      isLogin: false,
      req: {
        BASIC_LIFE: "0",
        BASIC_ACCIDENT: "0",
        BASIC_TRAVEL: "0",
        DOUBLE_LIFE: "0",
        DOUBLE_ACCIDENT: "0",
        DOUBLE_TRAVEL: "0",
      },
      msg: "請先登入",
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET,
      //鑫Money
      VUE_APP_LINK_XINMONEY: process.env.VUE_APP_LINK_XINMONEY,
      //iMoney
      VUE_APP_LINK_IMONEY: process.env.VUE_APP_LINK_IMONEY,
      //立即投保-1
      VUE_APP_LINK_INSURED1: process.env.VUE_APP_LINK_INSURED1,
      //立即投保-2
      VUE_APP_LINK_INSURED2: process.env.VUE_APP_LINK_INSURED2,
      //立即投保-3
      VUE_APP_LINK_INSURED3: process.env.VUE_APP_LINK_INSURED3,
      //立即投保-4
      VUE_APP_LINK_INSURED4: process.env.VUE_APP_LINK_INSURED4,
      //立即投保-5
      VUE_APP_LINK_INSURED5: process.env.VUE_APP_LINK_INSURED5,
    };
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then((m) => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      (m) => {}
    );
    this.getQual();

    import(
      "@/assets/webpage/js/vendor/jquery-fancyform/jquery-fancyform-min.js"
    ).then((m) => {});
    import("@/assets/webpage/js/vendor/slick/slick.js").then((m) => {});
  },
  mounted() {
    //取得名額
    this.getQuota();

    this.$nextTick(() => {
      this.initFun();
    });
  },
  methods: {
    // 取得名額
    getQuota() {
      let vVue = this;
      this.$cathayAxios.post(DTODAVZ1.getQuota, {}).then((resp) => {
        if (resp.returnCode == 0) {
          let QuotaData = resp.data || {};
          if (QuotaData) {
            vVue.req = QuotaData.detail.data;
          }
        }
      });
    },
    // 取得活動資格
    getQual() {
      // let cVue = this;
      // this.$cathayAxios.post(DTODAVZ1.getQual, {}).then(resp => {
      //   if (resp.returnCode == 0) {
      //     let is_chk = resp.data || false;
      //     if (!is_chk) {
      //       cVue.showAlert();
      //     }
      //   } else {
      //     cVue.showAlert();
      //   }
      // });
    },
    // 長度不足3補0
    patchZERO(value) {
      if (isNaN(value)) {
        return "000";
      }
      value = String(value);
      let Strlength = value.length;
      if (Strlength < 3) {
        let patchLength = 3 - Strlength;
        for (var i = 0; i < patchLength; i++) {
          value = "0" + value;
        }
      }
      return value;
    },
    // 回國泰人壽網頁
    showAlert() {
      $.magnificPopup.open({
        items: { src: "#CI_LINK_MSG2", type: "inline" },
        closeOnBgClick: false,
        enableEscapeKey: false,
      });
      setTimeout(() => {
        this.gotoCathayLife();
      }, 3000);
    },
    // 前往國泰人壽
    gotoCathayLife() {
      window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
    },
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300,
      };
      let move = $("#" + id).offset().top - 65;
      $("html").animate({ scrollTop: move }, this.animationTime);
    },
    initFun() {
      $("#CI_Link").on("click", (e) => {
        e.preventDefault();
        $.magnificPopup.open({
          items: { src: "#CI_LINK_MSG", type: "inline" },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
          closeOnBgClick: false,
          enableEscapeKey: false,
        });
      });
    },
  },
};
</script>
<style
  src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css"
></style>
<style scoped src="@/assets/webpage/js/vendor/slick/slick-min.css"></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/slick/slick-theme-min.css"
></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css"
></style>
<style scoped src="@/assets/webpage/css/common/normalize-min.css"></style>
<style scoped src="@/assets/webpage/css/common/animate-min.css"></style>
<style scoped src="@/assets/webpage/css/common/layout-min.css"></style>
<style scoped src="@/assets/webpage/css/form-min.css"></style>
<style scoped src="@/assets/webpage/css/product-min.css"></style>
<style scoped src="@/assets/webpage/css/index.css"></style>
<style scoped src="@/assets/webpage/css/common/main.css"></style>
<style scoped src="@/assets/third-party/css/font-awesome.min.css"></style>

<style scoped>
.c-popup__content {
  background-color: white;
}

.section1 {
  zoom: 100%;
}
.button_margin {
  margin-top: 80px;
}
@media screen and (min-width: 765px) and (max-width: 1023px) {
  .section1 {
    zoom: 70%;
  }
  .button_margin {
    margin-top: 80px;
  }
}
@media screen and (min-width: 600px) and (max-width: 764px) {
  .section1 {
    zoom: 100%;
  }
  .button_margin {
    margin-top: 0px;
  }
}
@media screen and (min-width: 530px) and (max-width: 599px) {
  .section1 {
    zoom: 80%;
  }
  .button_margin {
    margin-top: 0px;
  }
}
@media screen and (min-width: 376px) and (max-width: 529px) {
  .section1 {
    zoom: 60%;
  }
  .button_margin {
    margin-top: 0px;
  }
}
@media screen and (max-width: 375px) {
  .section1 {
    zoom: 50%;
  }
  .button_margin {
    margin-top: 0px;
  }
}

.img1 {
  width: 482px;
  height: 310px;
  background: url("~@/assets/webpage/action1/images/section1/section1_1_482x310.jpg")
    center center no-repeat;
  margin: 0 auto;
}
.img2 {
  width: 482px;
  height: 310px;
  background: url("~@/assets/webpage/action1/images/section1/section1_2_482x310.jpg")
    center center no-repeat;
  margin: 0 auto;
}
</style>
<style scoped>
.content_font {
  font-size: 16px;
  line-height: 1.5;
  color: #666;
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
}
.number_1 {
  position: absolute;
  z-index: 2;
  left: 8%;
  top: 58%;
  letter-spacing: 20px;
  font-size: 40px;
}
.number_2 {
  position: absolute;
  z-index: 2;
  left: 40%;
  top: 58%;
  letter-spacing: 20px;
  font-size: 40px;
}
.number_3 {
  position: absolute;
  z-index: 2;
  left: 72%;
  top: 58%;
  letter-spacing: 20px;
  font-size: 40px;
}
.table_td {
  border: 1px solid;
  padding: 2.5px 5px;
}
</style>
